import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import LessonForm from './LessonForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditLessonScreen() {
  const { weekNumber, weekId, id } = useParams();

  const api = Api.Lesson.useReadItemAsAdmin(id ?? '');

  if (!api.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Lesson"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/lessons`,
            },
          ]}
        />
        <LessonForm existing={api.data} />
      </Stack>
    </ScreenWrap>
  );
}
